<template>
  <div class="page-wrapper section-space--inner--60">
    <div class="container posting-border p-3">
      <div class="row">
        <div class="col-md-12">
          <div class="posting-content d-flex justify-content-center">
            <div class="content-link">
              <div class="d-flex mb-3">
                <!-- <div class="p-1" v-if="prevLink">
                  <a
                    @click="getData(prevLink)"
                    href="javascript:;"
                    class="btn btn button-pagination page-link pl-3 pr-3"
                  >
                    <i class="fa fa-angle-left"></i>
                  </a>
                </div>
                <div class="p-1" v-else>
                  <a
                    href="javascript:;"
                    class="btn button-pagination page-link disabled pl-3 pr-3"
                    aria-disabled="true"
                  >
                    <i class="fa fa-angle-left"></i>
                  </a>
                </div> -->
                <div class="p-1 w-100 text-center">
                  <h3 style="color: #f0542d">Sosial Media</h3>
                </div>
                <!-- <div class="ml-auto p-1" v-if="nextLink">
                  <a
                    @click="getData(nextLink)"
                    href="javascript:;"
                    class="btn button-pagination page-link pl-3 pr-3"
                  >
                    <i class="fa fa-angle-right"></i>
                  </a>
                </div>
                <div class="ml-auto p-1" v-else>
                  <a
                    href="javascript:;"
                    class="btn button-pagination page-link disabled pl-3 pr-3"
                    aria-disabled="true"
                  >
                    <i class="fa fa-angle-right"></i>
                  </a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <!-- {{ posting.length }} -->

      <!-- <div v-if="posting.length > 0">
        <div
          class="posting-content d-flex justify-content-center mb-5"
          v-for="post in posting"
          :key="post.id"
        >
          <div class="content-box p-5">
            <div class="profile-header">
              <div class="d-flex align-self-center bd-highlight mb-3">
                <div class="p-2 bd-highlight">
                  <div class="image-profile">
                    <img :src="post.user.avatar" alt="" />
                  </div>
                </div>
                <div class="p-2 bd-highlight">
                  <div class="profile-name">
                    {{ post.user.name ? post.user.name : "" }}
                  </div>
                  <div class="date-posting">
                    {{ formattedDate(post.created_at) }}
                  </div>
                </div>
                <div class="p-2 bd-highlight ml-auto d-flex align-items-center">
                  <div
                    class="status-profile text-center"
                    v-for="status in post.user.role"
                    :key="status.id"
                  >
                    <p>
                      {{ status.name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-posting" v-if="post.file">
              <img :src="post.file.path" alt="" />
            </div>
            <div class="content-posting" v-else>
              <img src="@/assets/images/global/list_empty.png" alt="" />
            </div>
            <div class="content-caption mt-3">
              <p>
                {{ post.body }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="posting-content d-flex justify-content-center mb-5">
          <div class="content-box p-5">
            <div class="content-posting text-center">
              <p>Mohon maaf belum ada postingan yang tersedia.</p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="container">
        <div class="card border-0 mt-4 mb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <stack
                  :column-min-width="250"
                  :gutter-width="15"
                  :gutter-height="15"
                  monitor-images-loaded
                >
                  <stack-item
                    v-for="(item, index) in posting"
                    :key="`key_${index}`"
                    style="transition: transform 300ms"
                  >
                    <router-link :to="`/postingan/detail/${item.id}`">
                      <img v-if="item.file" :src="item.file.path" />
                      <img
                        v-else
                        src="@/assets/images/global/list_empty.png"
                        alt=""
                      />
                    </router-link>
                  </stack-item>
                </stack>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col text-center" v-if="nextLink">
            <button
              @click="getData(nextLink)"
              class="btn btn-default button-pagination"
            >
              LIHAT LEBIH BANYAK
            </button>
          </div>

          <div class="col text-center" v-else>
            <a
              href="javascript:;"
              class="btn button-pagination disabled"
              aria-disabled="true"
            >
              LIHAT LEBIH BANYAK
            </a>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>
<script>
import broker from "../../utils/broker";
import moment from "moment";
import { Stack, StackItem } from "vue-stack-grid";

export default {
  props: ["meta"],
  components: {
    Stack,
    StackItem,
  },
  data() {
    return {
      limit: 10,
      nextLink: null,
      prevLink: null,
      posting: [],
      page: 1,
    };
  },
  mounted() {
    this.getData(1);
  },
  methods: {
    formattedDate(date) {
      moment.locale("id");
      return moment(date).format("DD MMMM YYYY HH:MM");
    },
    getData(page) {
      let self = this;
      broker.fetch
        .get(`/webschool/socmed?limit=${self.limit}&page=${page}`)
        .then((res) => {
          res.data.data.forEach((item) => {
            this.posting.push(item);
          });

          if (res.data.links) {
            self.prevLink = res.data.links.prev;
            self.nextLink = res.data.links.next;
          }
          // const data = res.data.data;
          // const meta = res.data.meta;
          // this.extracurricular = data;
          // this.currentPage = meta.current_page;
          // this.lastPage = meta.last_page;
          // this.pageNumbers();
        });
    },
    // goPage(type) {
    //   let number = 0;
    //   if (type === "next") {
    //     number = this.currentPage + 1;
    //   } else {
    //     number = this.currentPage - 1;
    //   }

    //   broker.fetch
    //     .get(
    //       `/webschool/content?page=${number}&limit=${this.limit}&types[]=extracurricular&status=published`
    //     )
    //     .then((res) => {
    //       const data = res.data.data;
    //       const meta = res.data.meta;
    //       this.extracurricular = data;
    //       this.currentPage = meta.current_page;
    //       this.lastPage = meta.last_page;
    //       this.pageNumbers();
    //     });
    // },
    // pageNumbers() {
    //   var result = [];
    //   if (this.lastPage - this.currentPage <= 2) {
    //     // if (this.currentPage > this.lastPage - this.limit) {
    //     // result.push(this.lastPage - 2, this.lastPage - 1, this.lastPage);
    //     if (this.lastPage - 2 > 0) result.push(this.lastPage - 2);

    //     if (this.lastPage - 1 > 0) result.push(this.lastPage - 1);

    //     if (this.lastPage) result.push(this.lastPage);
    //   } else {
    //     result.push(
    //       this.currentPage,
    //       this.currentPage + 1,
    //       this.currentPage + 2,
    //       "...",
    //       this.lastPage
    //     );
    //   }

    //   this.paging = result;
    // },
    // test() {
    //   console.log("test");
    // },
  },
};
</script>

<style scoped>
.row-button-list {
  margin-left: 120px;
}

.content-link {
  width: 560px;
}

.image-profile img {
  width: 60px;
  height: 60px;
  border-radius: 30px;
}
.content-box {
  /* border: 1px solid #000000; */
  height: auto;
  width: 560px;
  background: #ffffff;
  box-shadow: 1px 4px 19px rgba(75, 75, 75, 0.08);
  border-radius: 5px;
  box-sizing: border-box;
}

.profile-header .profile-name {
  color: #000000;
  font-size: 18px;
  font-weight: bold;
}

.profile-header .date-posting {
  font-size: 12px;
  color: #9597a1;
}
.profile-header .status-profile {
  background: #f0542d;
  /* width: 59px; */
  height: 23px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  padding: 0 6px 0 6px;
}

.content-posting {
  width: 100%;
  height: auto;
}

.content-posting img {
  width: 100%;
  max-height: 400px;
  height: auto;
}

.content-caption {
  font-family: Roboto;

  color: #525252;
  letter-spacing: -0.01em;
  font-size: 14px;
  line-height: 143.7%;
  font-weight: normal;
}
.button-pagination {
  border: 1px solid #f0542d;
  color: #f0542d;
}
.button-pagination:hover {
  border: 1px solid #f0542d;
  color: #ffffff;
  background: #f0542d;
}
</style>
<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}
</style>
